import {
  HeartHalf, MaskHappy, WarningDiamond, Fire, Compass, Lightning, ShieldStar,
  Waves, DeviceMobile, Target, Signpost, ArrowUUpLeft, Sparkle,
} from "@phosphor-icons/react";

const MAP = {
  HeartHalf, Mask: MaskHappy, WarningDiamond, Fire, Compass, Lightning, ShieldStar,
  Waves, DeviceMobile, Target, Signpost, ArrowUUpLeft, Sparkle,
};

export function AssessmentIcon({ name, ...props }) {
  const Icon = MAP[name] || Sparkle;
  return <Icon {...props} />;
}
